import { Injectable } from '@angular/core';
import { Http , Headers, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';
import { URL_SERVICIOS_LOCALES, NUBE_AWS, URL_SERVICIOS_AWS } from '../../config/url.servicio'
import { Storage } from '@ionic/storage'
import { map } from 'rxjs/operators';
import { ParametrosGeneralesRedux } from '../redux/parametrosgenerales/parametrosgenerales';
import { CajaProvider } from '../caja/caja';
import { Store } from '@ngrx/store';
import { AppState } from '../../app/app.reducer';
import { SetParametrosgeneralesAction, UnsetParametrosgeneralesAction } from '../../pages/parametros-generales/state/parametrosgenerales/parametrosgenerales.accions';

@Injectable()
export class PushProvider {
  token:string
  usuarioId: number
  cachedData: any = null;
  constructor(public http: Http, public storages:Storage,
    public servicio: CajaProvider
  ) {
    this.storages.get('token').then((val) => {
      this.token = val
  });

  this.storages.get('usuariosId').then((usuario) => {
    this.usuarioId = usuario
  });

  }

  buscar(companiasId:any) {
    let url = !NUBE_AWS ? URL_SERVICIOS_LOCALES: URL_SERVICIOS_AWS
    let data = {
      name: "buscarPush",
      parameters : {companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option

    return this.http.post(`${url}/procedure`, data, options)
     .map((data)=> data.json())

  }

  procesarDatosPush ( companiasId){
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/procesarDatosPush`, datos, options)
}

eliminar(data: any) {
  let url = !NUBE_AWS ? URL_SERVICIOS_LOCALES: URL_SERVICIOS_AWS
  let values = {
    name: "dataDynamicCrud",
    parameters : {queHago: 'E',pushId:data,nombreTabla:'push', name:"dataDynamicCrud"}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option

  return this.http.post(`${url}/procedure`, values, options)
   .map((data)=> data.json())
 }

  buscarParametrosGenerales(companiasId:any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarparametrosGenerales",
        parameters : {companiaId: companiasId, usuariosId: this.usuarioId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  buscarParametrosGeneralesConUsuario(companiasId:any,usuariosId:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarparametrosGenerales",
      parameters : {companiaId: companiasId, usuariosId: usuariosId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}


  buscarParametrosGeneralesParaMaestro(companiasId:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarParametrosGeralesMaestro",
        parameters : {companiaId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES

      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.get(`${url}/proceso/buscarParametrosGeralesMaestro?companiaId=${companiasId}`, options)
      .map((data) => data.json())
    }
  }

  actualizarParametrosGenerales(parametrosGenerales: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "dataDynamicCrud",
        parameters : {...parametrosGenerales}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      //?name=dataDynamicCrud&paisesId=${pais.paisesId}&codigoPais=${pais.codigoPais}&nombrePais=${pais.nombrePais}&nombreTabla=paises
      return this.http.put(`${url}/query`, parametrosGenerales, options)
    }
  }

  buscarTodoUbicacion(name:string,contenedorId:any) {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=${name}&contenedorId=${contenedorId}`)
    .map((data) => data.json())
  }


  cualquiercosa(afn:any) {
    if (this.contieneComandosPeligrosos(afn)) {
      alert('Entrada inválida');
      return;
    }
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "cualquiercosa",
        parameters : {afn: afn}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/proceso/cualquiercosa?afn=${afn}`)
      .map((data) => data.json())
    }
  }

  // Validar que afn no contenga comandos peligrosos
// contieneComandosPeligrosos(afn: string) {
//   const patrones = /(drop|truncate|delete|--|#|;|\/\*)/i;
//   return patrones.test(afn);
// }
contieneComandosPeligrosos(afn: string) {
  // Bloquear comandos peligrosos como DROP, TRUNCATE, DELETE, etc.
  const patrones = /(drop|truncate|delete|--|#|;|\/\*|\*\/|\bupdate\b|\balter\b)/i;

  // Verificar que no contenga ningún comando peligroso
  if (patrones.test(afn)) {
    return true; // Si contiene comandos peligrosos, bloquear la operación
  }

  // Verificar si la consulta contiene la palabra 'SELECT' (en mayúsculas o minúsculas)
  const esSelect = /\bselect\b/i.test(afn);

  // Solo permitir SELECT, de lo contrario, bloquear
  return !esSelect; // Si no es un SELECT válido, bloquear
}


  actualizarParametrosGeneralesCreditos(companiasId:any, datosCreditos:any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "actualizarParametrosGeneralesCreditos",
        parameters : {companiaId: companiasId,datosCreditos:JSON.stringify(datosCreditos)}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  buscarParametrosGeneralesCreditos(companiasId:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarParametrosGeneralesCreditos",
      parameters : {companiaId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

actualizarParametrosGeneralesOtrosDatos(companiasId:any, datosGenerales:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "actualizarParametrosGeneralesOtrosDatos",
    parameters : {companiaId: companiasId,datosGenerales:JSON.stringify(datosGenerales)}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

buscarParametrosGeneralesOtrosDatos(companiasId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarParametrosGeneralesOtrosDatos",
    parameters : {companiaId: companiasId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

async buscarCupoAprobado(companiasId:any,clientesId:any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarCupoAprobado",
        parameters : {companiasId:companiasId,
          clientesId:clientesId
        }
      }

      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).toPromise();

  } catch (error) {
      // Manejo de errores
      console.error('Error en buscarCuentaPorCobrar:', error);
      throw error;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/push/push.ts